/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Luba_Katanga3Inputs */

const en__field__enum_nativelanguage_luba_katanga3 = /** @type {(inputs: _Field__Enum_Nativelanguage_Luba_Katanga3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luba_Katanga`)
};

const de__field__enum_nativelanguage_luba_katanga3 = /** @type {(inputs: _Field__Enum_Nativelanguage_Luba_Katanga3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luba_Katanga`)
};

/**
* | output |
* | --- |
* | "Luba_Katanga" |
*
* @param {_Field__Enum_Nativelanguage_Luba_Katanga3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_luba_katanga3 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Luba_Katanga3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Luba_Katanga3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_luba_katanga3(inputs)
	return de__field__enum_nativelanguage_luba_katanga3(inputs)
});
export { _field__enum_nativelanguage_luba_katanga3 as "_field__enum_nativeLanguage_Luba_Katanga" }